import { defineComponent as _defineComponent } from 'vue'
import { nextTick, PropType, ref, watch } from 'vue';
import MessageItem from '@/modules/Chat/components/MessageItem.vue';
import { ChatRenderedMessage } from '@/modules/Chat/interfaces/ChatRenderedMessage';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatMessageList',
  props: {
    messageList: {
        type: Array as PropType<ChatRenderedMessage[]>,
        required: true,
    },
    selectedProjectId: {
        type: String as PropType<string | null>,
        default: null,
    },
    shouldShowActions: {
        type: Boolean,
        required: true,
    },
},
  setup(__props) {

const props = __props;



const messageListRef = ref<HTMLElement | null>(null);

watch(
    () => props.messageList,
    async () => {
        await nextTick();

        if (messageListRef.value == null) {
            return;
        }

        messageListRef.value.scrollTop = messageListRef.value.scrollHeight - messageListRef.value.clientHeight;
    },
    { deep: true, immediate: true },
);

return { __sfc: true,props, messageListRef, MessageItem }
}

})